export const noError = 0;

export const options = {
  // collect_way_flag: [
  //   { value: '1', label: '세금 계산서' },
  //   { value: '2', label: '현금 영수증 미 발행' },
  //   { value: '3', label: '현금 영수증 발행' },
  //   { value: '4', label: '카드 결제' },
  //   // { value: '9', label: '상계처리' },
  // ],
  delivery_way_flag: [
    { value: "11", label: "사업지납품" },
    { value: "12", label: "납품지납품" },
    { value: "2", label: "시공" },
    { value: "3", label: "화물(택배,퀵)" },
    { value: "6", label: "공장출고" },
    { value: "7", label: "조립" },
    { value: "8", label: "실측" },
    { value: "9", label: "작업" },
  ],
  collect_way_flag: [
    { value: "1", label: "현금" },
    { value: "2", label: "통장" },
    { value: "4", label: "수표" },
    { value: "5", label: "어음" },
    { value: "3", label: "카드" },
    { value: "9", label: "매입" },
  ],
  pay_way_flag: [
    { value: "1", label: "현금" },
    { value: "2", label: "통장" },
    { value: "4", label: "수표" },
    { value: "5", label: "어음" },
    { value: "3", label: "카드" },
    // { value: '9', label: '상계' },
  ],
  account_type_flag: [
    { value: 1, label: "현금" },
    { value: 2, label: "통장" },
    { value: 3, label: "카드" },
  ],
  customer_type_flag: [
    { value: 1, label: "매출처" },
    { value: 2, label: "매입처" },
    { value: 3, label: "매입매출처" },
    { value: 4, label: "임시거래처" },
    { value: 5, label: "AS거래처" },
  ],
  // customer_grade_flag: [
  //   { value: null, label: '' },
  //   { value: 1, label: '대리점' },
  //   { value: 2, label: '일반납품' },
  //   { value: 3, label: '일반시공' },
  //   { value: 4, label: '보상판매' },
  //   { value: 5, label: '일반판매' },
  //   { value: 6, label: '대리점(C)' },
  //   { value: 7, label: '대리점(B)' },
  //   { value: 8, label: '일반판매(C)' },
  //   { value: 9, label: 'A/S' },
  //   { value: 10, label: '일반매입' },
  //   { value: 11, label: '3연동대리점' },
  //   { value: 12, label: '3연동소비자' },
  //   { value: 13, label: '3연동인테리어' },
  //   { value: 14, label: '대리점3연동' },
  // ],
  invoice_type_flag: [
    { value: "1", label: "사업자" },
    { value: "0", label: "비사업자" },
  ],
  glass_chamfer_type: [
    { value: "h1", label: "가로1" },
    { value: "h2", label: "가로2" },
    { value: "v1", label: "세로1" },
    { value: "v2", label: "세로2" },
    { value: "h1v1", label: "가로1+세로1" },
    { value: "h1v2", label: "가로1+세로2" },
    { value: "h2v1", label: "가로2+세로1" },
    { value: "h2v2", label: "가로2+세로2" },
    { value: null, label: "면취무" },
    { value: "no_chamfer", label: "없음" },
  ],
  note_type_flag: [
    { value: "B", label: "어음" },
    { value: "C", label: "수표" },
  ],
  note_in_flag: [
    { value: "1", label: "발행" },
    { value: "2", label: "수금" },
    { value: "3", label: "차입" },
    { value: "4", label: "환입" },
    { value: "9", label: "기타" },
  ],
  note_out_flag: [
    { value: "0", label: "미결" },
    { value: "1", label: "수탁" },
    { value: "2", label: "결제" },
    { value: "3", label: "할인" },
    { value: "9", label: "기타" },
  ],
  resolve_pay_way_flag(value) {
    const type = this.pay_way_flag.filter((f) => f.value === value);
    return type ? type[0].label : "";
  },
  resolve_collect_way_flag(value) {
    if (!value) {
      return "";
    }
    const type = this.collect_way_flag.filter((f) => f.value === value);
    return type ? type[0].label : "";
  },
  resolve_customer_type_flag(value) {
    const type = this.customer_type_flag.filter((f) => f.value === value);
    return type ? type[0].label : "";
  },
};

export const width = {
  index: 40,
  indexw: 40,
  date: 80,
  datetime: 135,
  username: 80,
  selection: 35,
  size: 90,
  amount: 50,
  unit_name: 50,
  price: 85,
};

export const masks = {
  crn: "###-##-#####",
  ssn: "######-#######",
  // tel: ['####-####', '##-###-####', '###-###-####', '###-####-####']
  tel: { type: "tel" },
  email: { type: "email" },
};

export const regex = {
  float: /^\d+(?:[.]?[\d]?[\d])?$/,
};

export const mask_tokens = {
  float: {
    "#": {
      pattern: regex.float,
    },
  },
};

export const default_lang = "ko";

export function organizeProductType(types, limitSecondLevel = false) {
  let options = types.filter((c) => !c.parent_id);
  options.forEach((c1) => {
    let children2 = types.filter((c2) => c2.parent_id === c1.id);
    if (children2.length > 0) {
      if (!limitSecondLevel) {
        children2.forEach((c2) => {
          let children3 = types.filter((c3) => c3.parent_id === c2.id);
          if (children3.length > 0) {
            c2.children = children3;
          }
        });
      }
      c1.children = children2;
    }
  });
  return options;
}
